import { mapActions, mapGetters, mapMutations } from "vuex";
import { maxLength, minLength } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";

export default {
    name: "type-payment",
    mixin: [validationMixin],
    data() {
        return {
            defaultBasket: "",
            liqpay: "",
            payload: {
                payment: "",
                user_comment: "",
                last_name: "",
            },
            validationErrors: {},
            disable: false,
            test: "",
            affiliateId: "",
        };
    },
    validations() {
        return {
            payload: {
                user_comment: {
                    minLength: minLength(1),
                    maxLength: maxLength(300),
                },
            },
        };
    },
    created() {
        this.setUserData();
        // console.log(`${this.userInfo.dateDelivery} ${this.userInfo.timeDelivery}:00`);
        if (!this.paymentMethodsList) {
            this.fetchPaymentList().then(() => {
                this.payload.payment = this.paymentMethodsList[0];
            });
        } else {
            this.payload.payment = this.paymentMethodsList[0];
        }
    },
    // 'transactionResult': function () {
    //   this.liqpay = this.transactionResult
    // },
    computed: {
        ...mapGetters({
            paymentMethodsList: "paymentMethods/paymentMethodsList",
            paymentMethodsListLoading: "paymentMethods/paymentMethodsListLoading",
            userInfo: "order/userInfo",
            basket: "basket/basket",
            count: "basket/count",
            userAddress: "order/userAddress",
            orderResult: "basket/orderResult",
            invoiceResult: "payment/invoiceResult",
            orderLoading: "basket/orderLoading",
            user: "profile/user",
            transactionResult: "payment/transactionResult",
            enteredCode: "basket/enteredCode",
        }),

        userCommentErrors() {
            let error = [];
            if (!this.$v.payload.user_comment.$dirty) {
                return error;
            }
            if (!this.$v.payload.user_comment.maxLength) {
                error.push(this.$t("validationMax") + " 300");
            }
            if (!this.$v.payload.user_comment.minLength) {
                error.push(this.$t("validationMin") + " 5");
            }
            if (this.validationErrors.user_comment) {
                this.validationErrors.user_comment.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        totalAmount() {
            return this.basket.reduce((accumulator, currentValue) => {
                return (
                    accumulator +
                    (currentValue.discount_price ? currentValue.discount_price : currentValue.price) *
                        currentValue.select_count
                );
            }, 0);
        },
        totalSum() {
            return this.basket.reduce((accumulator, currentValue) => {
                return accumulator + currentValue.price * currentValue.select_count;
            }, 0);
        },
        amountWithDiscount() {
            return this.basket.reduce((accumulator, currentValue) => {
                let totalSum = accumulator + currentValue.min_price * currentValue.select_count;
                return totalSum;
            }, 0);
        },
        totalAmountWithDelivery() {
            return this.totalAmount;
        },
    },
    methods: {
        ...mapActions({
            fetchPaymentList: `paymentMethods/GET_PAYMENT_METHODS_LIST`,
            sendBasket: `basket/SEND_BASKET`,
            createOrder: `basket/CREATE_ORDER`,
            createInvoice: "payment/CREATE_INVOICE",
            createTransaction: "payment/CREATE_TRANSACTION",
        }),
        ...mapMutations({
            changeShowOrder: "basket/CHANGE_SHOW_ORDER",
            changeUserInfo: "order/CHANGE_USER_INFO",
            resetBasket: "basket/RESET_BASKET",
            resetUserInfo: "order/RESET_USER_INFO",
            resetUserAddress: "order/RESET_USER_ADDRESS",
            resetSteps: "order/RESET_STEP_BUY_FLOW",
            changePopupConfirmPayment: `payment/CHANGE_POPUP_CONFIRM_PAYMENT`,
            backStep: "order/BACK_STEP_BUY_FLOW",
            ressetCode: "basket/ENTERED_CODE",
        }),
        setUserData() {
            this.payload.user_comment = this.userInfo.user_comment;
        },
        submit() {
            this.payload.last_name = this.userInfo.last_name;
            localStorage.removeItem("useDiscount");
            this.changeUserInfo(this.payload);
            let obj = {};
            if (this.userInfo.dateDelivery.length) {
                obj.delivery_date = this.userInfo.dateDelivery;
                obj.delivery_time = this.userInfo.timeDelivery;
            } else {
                obj.delivery_date = "";
                obj.delivery_time = "";
            }
            //----------------------client_id
            console.log(this.userInfo);
            obj.agent_client_id = this.userInfo.agent_client_id;
            obj.delivery_method_id = this.userInfo.delivery.id;
            obj.payment_method_id = this.userInfo.payment.id;
            obj.user_comment = this.userInfo.user_comment;
            obj.total_sum = this.totalAmount;
            obj.phone = this.userInfo.phone.replace(/[\s.,%()-]/g, "");
            obj.email = this.userInfo.email;
            obj.name = this.userInfo.name ? this.userInfo.name : "";
            obj.last_name = this.userInfo.second_name ? this.userInfo.second_name : this.user.last_name;
            obj.second_name = this.userInfo.second_name ? this.userInfo.second_name : this.user.last_name;

            if (this.userInfo.recipient > 0) {
                obj.other_phone = this.userInfo.other_phone.replace(/[\s.,%()-]/g, "");
                obj.other_email = this.userInfo.other_email;
                obj.other_name = this.userInfo.other_name ? this.userInfo.other_name : "";
                obj.other_last_name = this.userInfo.other_second_name ? this.userInfo.other_second_name : this.user.last_name;
                obj.other_second_name = this.userInfo.other_second_name ? this.userInfo.other_second_name : this.user.last_name;
            }

            this.disable = true;
            if (this.enteredCode) {
                this.defaultBasket = this.basket;
                this.defaultBasket.forEach(product => {
                    product.select_price = product.min_price;
                });
                this.ressetCode("");
                obj.sum = this.amountWithDiscount;
                obj.promo_code = this.enteredCode;
            } else {
                this.defaultBasket = this.basket;
                obj.sum = this.totalSum;
                obj.promo_code = null;
            }

            if (this.userInfo.recipient === "") {
                obj.recipient = 1;
            } else {
                obj.recipient = this.userInfo.recipient;
            }
            if (this.userInfo.delivery.id === 5) {
                obj.delivery_address = this.userAddress.town + ", " + this.userAddress.department;
            } else if (this.userInfo.delivery.id === 1) {
                obj.delivery_address = "Самовывоз";
                obj.affiliate_id = this.userInfo.affiliate_id;
                obj.affiliate_id = this.userInfo.affiliate_id;
            } else {
                obj.delivery_address =
                    this.userInfo.city +
                    ", " +
                    this.userInfo.street +
                    " " +
                    this.userInfo.house +
                    "/" +
                    this.userInfo.flat;
            }
            this.sendBasket(this.defaultBasket)
                .then(() => {
                    this.createOrder(obj)
                        .then(() => {
                            // JSON.stringify(localStorage.setItem('orderResult', JSON.stringify(this.orderResult)))
                            // this.$router.push({name: 'thank-you'}).catch(() => {
                            //   console.log('')
                            // })
                            if (this.payload.payment.id === 3) {
                                // console.log(444);
                                // this.$toasted.success(this.$t('createInvoices'));
                                // this.createTransactionLocal()
                                // this.resetBasket();
                                this.createTransaction({ order_id: this.orderResult.data.data.id }).then(() => {
                                    setTimeout(() => {
                                        this.liqpay = this.transactionResult;
                                        setTimeout(function() {
                                            document.getElementById("liqpayForm").submit();
                                        }, 100);
                                        this.resetBasket();
                                    }, 200);
                                });
                            } else {
                                JSON.stringify(localStorage.setItem("orderResult", JSON.stringify(this.orderResult)));
                                this.$router.push({ name: "thank-you" }).catch(() => {
                                    console.log("");
                                });
                                this.changeShowOrder(false);
                                this.resetBasket();
                                this.resetUserInfo();
                                this.resetUserAddress();
                                this.resetSteps();
                            }
                            setTimeout(() => {
                                this.disable = false;
                            }, 500);
                        })
                        .catch(error => {
                            console.log(error);
                            // if (error.response.status === 418) {
                            //   this.$toasted.error(error.response.data.message);
                            // } else if (error.response.status === 400) {
                            //   this.$toasted.error(this.$t('notEnoughBonuses'));
                            // }
                            // setTimeout(() => {
                            //   this.disable = false
                            // }, 500)
                        });
                })
                .catch(error => {
                    console.log(error);
                    if (error.response.status === 418) {
                        this.$toasted.error(error.response.data.message);
                    }
                    setTimeout(() => {
                        this.disable = false;
                    }, 500);
                });
            // console.log(obj)
            this.keepIn();
        },
        keepIn() {
            this.$session.clear();

            this.$session.set("address", this.userInfo);
            this.$session.set("order", this.userInfo.id);
            this.$session.set("order-date", this.userInfo.delivery_date);
            this.$session.set("phone", this.userInfo.phone);
            this.$session.set("sum", this.userInfo.total_sum);
            this.$session.set("affiliate_id", this.userInfo.affiliate_id);
        },
        createInvoiceLocal() {
            // const payloadInvoice = new FormData();
            // payloadInvoice.append('order_id', this.orderResult.id);
            console.log(this.orderResult, "orderResult");
            this.createInvoice({ order_id: this.orderResult.id, amount: 100 })
                .then(() => {
                    this.$toasted.success(this.$t("createInvoices"));
                    // console.log(this.invoiceResult);
                    this.createTransactionLocal();
                })
                .catch(error => {
                    console.log(error);
                    if (error.response.status === 422) {
                        const objErrors = error.response.data.errors;
                        for (let i in objErrors) {
                            objErrors[i].forEach(t => {
                                this.$toasted.error(t);
                            });
                        }
                    }
                }); // userInfo:'userInfo'
        },
        createTransactionLocal() {
            const payloadTransaction = new FormData();
            console.log(this.transactionResult, "transactionResult");
            payloadTransaction.append("invoice_id", this.invoiceResult.data.data.id);
            payloadTransaction.append("amount", this.invoiceResult.value);

            this.createTransaction(payloadTransaction)
                .then(() => {
                    this.$toasted.success(this.$t("successCreateTransaction")).goAway(10000);
                    this.changePopupConfirmPayment(true);
                    this.resetBasket();
                })
                .catch(error => {
                    if (error.response.status === 424) {
                        const objErrors = error.response.data;
                        this.$toasted.error(objErrors.message);
                    }
                    if (error.response.status === 422) {
                        const objErrors = error.response.data.errors;
                        for (let i in objErrors) {
                            objErrors[i].forEach(t => {
                                this.$toasted.error(t);
                            });
                        }
                    }
                });
        },
    },
};
